import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import DOMPurify from 'dompurify';

function Content() {
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedContent, setSelectedContent] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      const response = await fetch(`${apiUrl}/api/content`);
      const data = await response.json();
      
      if (data.success) {
        setContent(data.content);
      }
    } catch (error) {
      console.error('Error fetching content:', error);
    } finally {
      setLoading(false);
    }
  };

  const openModal = async (item) => {
    console.log('📄 Cargando contenido completo...');
    
    setSelectedContent({ ...item, loading: true });
    document.body.style.overflow = 'hidden';
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      const response = await fetch(`${apiUrl}/api/content/${item.id}`);
      const data = await response.json();
      
      if (data.success) {
        console.log('✅ Contenido completo recibido:', data.content);
        setSelectedContent(data.content);
      } else {
        console.error('❌ Error:', data.error);
        setSelectedContent(item);
      }
    } catch (error) {
      console.error('❌ Error al cargar contenido:', error);
      setSelectedContent(item);
    }
  };

  const closeModal = () => {
    setSelectedContent(null);
    document.body.style.overflow = 'auto';
  };

  if (loading) {
    return (
      <div style={{ position: 'relative', zIndex: 1 }}>
        <h2>Contenido Espiritual</h2>
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #667eea',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }}></div>
        </div>
      </div>
    );
  }

  if (content.length === 0) {
    return null;
  }

  return (
    <>
      <div style={{ position: 'relative', zIndex: 1 }}>
        <h2>Contenido Espiritual</h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          gap: '20px',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {content.map((item) => (
            <div 
              key={item.id} 
              className="content-card"
              onClick={() => openModal(item)}
              style={{ 
                cursor: 'pointer',
                maxWidth: '400px',
                justifySelf: content.length === 1 ? 'start' : 'stretch',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '';
              }}
            >
              {item.image_url && (
                <div style={{
                  width: '100%',
                  height: '180px',
                  backgroundImage: `url(${item.image_url})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  borderRadius: '12px 12px 0 0',
                  marginBottom: '15px'
                }}></div>
              )}
              <h3>{item.title}</h3>
              {item.description && <p>{item.description}</p>}
              <span style={{
                display: 'inline-block',
                padding: '4px 12px',
                background: 'rgba(102, 126, 234, 0.1)',
                color: '#667eea',
                borderRadius: '12px',
                fontSize: '0.85em',
                fontWeight: '600',
                marginTop: '10px',
                textTransform: 'capitalize'
              }}>
                {item.category}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Modal usando React Portal - se renderiza FUERA del DOM de la app */}
      {selectedContent && ReactDOM.createPortal(
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            padding: '20px',
            overflowY: 'auto'
          }}
          onClick={closeModal}
        >
          <div 
            style={{
              background: 'white',
              borderRadius: '20px',
              maxWidth: '700px',
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto',
              position: 'relative',
              boxShadow: '0 25px 50px rgba(0,0,0,0.3)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              style={{
                position: 'sticky',
                top: '15px',
                left: 'calc(100% - 55px)',
                background: 'white',
                border: 'none',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                cursor: 'pointer',
                fontSize: '1.5em',
                fontWeight: 'bold',
                color: '#4a5568',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
                float: 'right',
                marginBottom: '-40px'
              }}
            >
              ×
            </button>

            {selectedContent.image_url && (
              <div style={{
                width: '100%',
                height: window.innerWidth > 768 ? '450px' : '300px',
                backgroundImage: `url(${selectedContent.image_url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: '20px 20px 0 0'
              }}></div>
            )}
            
            <div style={{ padding: '30px', clear: 'both' }}>
              <div style={{ marginBottom: '15px' }}>
                <span style={{
                  display: 'inline-block',
                  padding: '6px 14px',
                  background: 'rgba(102, 126, 234, 0.1)',
                  color: '#667eea',
                  borderRadius: '15px',
                  fontSize: '0.9em',
                  fontWeight: '600',
                  textTransform: 'capitalize'
                }}>
                  {selectedContent.category}
                </span>
                <span style={{
                  display: 'inline-block',
                  padding: '6px 14px',
                  background: 'rgba(72, 187, 120, 0.1)',
                  color: '#38a169',
                  borderRadius: '15px',
                  fontSize: '0.9em',
                  fontWeight: '600',
                  marginLeft: '10px',
                  textTransform: 'capitalize'
                }}>
                  {selectedContent.content_type}
                </span>
              </div>

              <h2 style={{
                color: '#4a5568',
                marginBottom: '15px',
                fontSize: '1.8em',
                lineHeight: '1.2'
              }}>
                {selectedContent.title}
              </h2>

              {selectedContent.loading ? (
                <div style={{
                  textAlign: 'center',
                  padding: '40px',
                  color: '#718096'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #e2e8f0',
                    borderTop: '4px solid #667eea',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 15px'
                  }}></div>
                  Cargando contenido...
                </div>
              ) : (
                <>
                  {selectedContent.description && (
                    <p style={{
                      color: '#718096',
                      fontSize: '1.1em',
                      lineHeight: '1.6',
                      marginBottom: '20px',
                      fontWeight: '500'
                    }}>
                      {selectedContent.description}
                    </p>
                  )}

                  {selectedContent.full_content && (
                    <div 
                      style={{
                        color: '#4a5568',
                        fontSize: '1em',
                        lineHeight: '1.8',
                        borderTop: '2px solid #e2e8f0',
                        paddingTop: '20px',
                        marginTop: '20px'
                      }}
                      dangerouslySetInnerHTML={{ 
                        __html: DOMPurify.sanitize(selectedContent.full_content) 
                      }}
                    />
                  )}

                  {!selectedContent.full_content && !selectedContent.description && (
                    <p style={{
                      color: '#a0aec0',
                      fontStyle: 'italic',
                      textAlign: 'center',
                      padding: '20px'
                    }}>
                      No hay contenido adicional para mostrar
                    </p>
                  )}
                </>
              )}

              <button
                onClick={closeModal}
                style={{
                  marginTop: '30px',
                  padding: '12px 30px',
                  background: '#667eea',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  fontSize: '1em',
                  fontWeight: '600',
                  width: '100%',
                  transition: 'background 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.background = '#5a67d8'}
                onMouseLeave={(e) => e.target.style.background = '#667eea'}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @media (max-width: 768px) {
          .content-card {
            max-width: 100% !important;
          }
        }
      `}</style>
    </>
  );
}

export default Content;